<section>
  <div class="content-wrapper content">
    <h1 class="title has-text-centered">Policies & Terms</h1>
    <p class="has-text-centered has-text-grey">
      Effective Date: 01 November 2025
    </p>

    <hr />

    <h2 class="title is-4">Shipping & Delivery Policy</h2>
    <p>
      At <strong>Geekeno</strong>, all our products and services are digital in
      nature. No physical items are shipped. Once your payment is successfully
      processed, our team will reach out within <strong>24 hours</strong> to
      gather the necessary information required to prepare your order.
    </p>
    <p>
      Your completed deliverables (such as Brand Kits, Canva templates, or
      digital assets) will be provided via <strong>Google Drive</strong> and/or
      a <strong>Notion page</strong> within <strong>2 business days</strong> of
      receiving your details.
    </p>
    <p>
      You will receive access links through your registered email address.
      Please ensure the email provided at checkout is correct to avoid delivery
      delays.
    </p>

    <hr />

    <h2 class="title is-4">Cancellation & Refund Policy</h2>
    <p>
      Since all our offerings are customized and delivered digitally, we do not
      accept cancellations once the order has been confirmed and work has begun.
    </p>
    <p>
      However, if we do not hear back from you within
      <strong>24 hours</strong> of placing the order (after we reach out for
      necessary details), we will automatically cancel your order and issue a
      <strong>full refund</strong>
      to your original payment method.
    </p>
    <p>
      Refunds are processed within <strong>5–7 business days</strong>
      depending on your payment provider.
    </p>

    <hr />

    <h2 class="title is-4">Privacy Policy</h2>
    <p>
      We respect your privacy and are committed to protecting your personal
      information. The details you share with us — such as your name, email
      address, and payment information — are used solely for the purpose of
      processing your order and communicating with you about your project.
    </p>
    <p>
      We do not sell, trade, or rent your personal data to any third parties.
      Your information may be shared with trusted service providers such as
      <strong>Razorpay</strong> (for payments), <strong>Google Drive</strong>,
      and <strong>Notion</strong>
      (for file and content delivery), under their respective privacy standards.
    </p>
    <p>
      By using our website and purchasing from us, you consent to the collection
      and use of your data in accordance with this Privacy Policy.
    </p>

    <hr />

    <h2 class="title is-4">Terms & Conditions</h2>
    <p>
      By accessing and using this website (<a href="https://geekeno.com"
        >geekeno.com</a
      >), you agree to the following terms and conditions:
    </p>
    <ul>
      <li>
        All content and digital assets provided by Geekeno are the intellectual
        property of Geekeno unless otherwise stated.
      </li>
      <li>
        Purchased assets are for personal or business use only and may not be
        resold or redistributed.
      </li>
      <li>
        Geekeno reserves the right to modify or discontinue any product or
        service without prior notice.
      </li>
      <li>
        Prices are subject to change, but confirmed orders will always be
        honored at the purchase price.
      </li>
      <li>
        All communication regarding orders will be conducted via the email
        provided at checkout.
      </li>
    </ul>
    <p>
      For any disputes or concerns, please contact us directly before taking
      further action. We aim to resolve all issues amicably and professionally.
    </p>

    <hr />

    <h2 class="title is-4">Contact Us</h2>
    <p>
      For questions regarding these policies or your purchase, you can reach us
      at:
    </p>
    <ul>
      <li>
        Email: <a href="mailto:hello@geekeno.com">info&commat;geekeno.com</a>
      </li>
      <li>Phone: <a href="tel:919823994536">+91 98239 94536</a></li>
    </ul>

    <p>
      Geekeno reserves the rights to update these policies at any time. Please
      review these terms regularly to stay informed about our practices and the
      latest updates.
    </p>
  </div>
</section>
